import React, { ReactElement } from 'react';
import { Typography, makeStyles, Container } from '@material-ui/core';
import Gallery from '../../components/Gallery';
import { Fade } from 'react-awesome-reveal';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Helmet } from 'react-helmet';

interface Images {
    imageUrl: string;
    description: string;
}

const useClasses = makeStyles({
    root: {
        margin: '3rem 0',
    },
    title: {
        margin: '2rem 0',
        paddingBottom: '1.5rem',
    },
    projectContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
});

const projectImages: Array<Images> = [
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/0a318337-6799-41c5-b036-d3edb5f202aa.jpg',
        description: 'Isogenopak pipe work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/0b6157ea-341d-492c-862a-608fd294c779.jpg',
        description: 'Phenolic aluminium banding and edging.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/0d6d7246-4bc5-45a2-a115-a833fc833bde.jpg',
        description: 'Rolled casing pipework.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/2d9841c9-8eb0-4ab3-8303-8d5e72e057e0.jpg',
        description: 'Proclad with aluminium banding on duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/3766f337-2c4d-4ef8-a0a6-e78837936e62.jpg',
        description: 'Polyisobutylene (PIB) with aluminium banding to duct work',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/399aaba5-8422-4c61-97a1-54b6902183f9.jpg',
        description: 'Duct cladding , stucco aluminium.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/412bc7c4-1cdc-48e0-bbc0-4f5e4f95d71a.jpg',
        description: 'Polyisobutylene (PIB) to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/4264f1da-8e7c-4641-a237-821197d7d892.jpg',
        description: 'Aluminium Stucco to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/458d42e0-1eef-42f4-b553-7e064ca72e39.jpg',
        description: 'Aluminium Stucco sheets.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/531fddbf-7f98-4295-b5dd-83e8076cb665.jpg',
        description: 'Aluminium Stucco to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/74e8d7fc-20d8-4f9a-93b0-22ab66acfea1.jpg',
        description: 'Phenolic aluminium banding and edging.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/789e9da4-b3dc-45cb-b705-9a05c51facec.jpg',
        description: 'Aluminium Stucco to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/87cac8fa-4c6c-4634-9e95-73c2c59ad04f.jpg',
        description: 'Isogenopak pipe work',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/923e20bb-403a-4f33-b35e-ecfeb40c28b7.jpg',
        description: 'Plain aluminium stucco to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/92854300-fe74-4d1e-bde3-fa65b05ce685.jpg',
        description: 'Plain aluminium stucco to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/94ff6593-ad3f-40e1-b58a-3006a2294fdb.jpg',
        description: 'Polyisobutylene (PIB) with Aluminium banding.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/a10be3c8-8212-4454-8770-d13d46d6707b.jpg',
        description: 'Polished aluminium stucco.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/a79660fb-04ce-4b6e-9842-a796c87c9287.jpg',
        description: 'Rolled casing with valve bags to finish.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/b7f218cc-df07-4961-a001-256aa9853eef.jpg',
        description: 'Rolled casing with valve boxes to finish',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/bc48ce8d-5728-4c5c-8e4d-67c642cf20bb.jpg',
        description: 'Rolled casing with valve boxes to finish',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/bd2ad48c-f59d-42a4-b712-f2effaf0baaa.jpg',
        description: 'Rolled casing with valve bags to finish',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/c2de8458-16d8-485f-b9fe-e52db9526001.jpg',
        description: 'Aluminium plain stucco to duct work',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/ca5bc003-fcb5-4716-93e1-c0fd2e6a652d.jpg',
        description: 'Aluminium plain stucco to duct work',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/cffc0a3e-4abe-42c2-bc77-5f4370a95802.jpg',
        description: 'Proclad with aluminium banding to duct work.',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/da537061-1f91-4bba-8198-6d9716c9c5fe.jpg',
        description: 'Plain aluminium stucco',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/e1c0f578-4f1b-4e6c-a581-007037748d3c.jpg',
        description: 'Plain aluminium stucco',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/e5b2ef41-4324-4363-bad5-6d32f09e79a3.jpg',
        description: 'Aluminium stucco to duct work',
    },
    {
        imageUrl:
            'https://upgetgomedia.s3.eu-west-2.amazonaws.com/london-insulation/projects/ff437588-7fb0-46d5-82a7-df84e73ac33b.jpg',
        description: 'Polyisobutylene (PIB) to duct work',
    },
];

function ProjectPage(): ReactElement {
    const classes = useClasses();

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Helmet>
                    <title>London Insulation Services | Projects</title>
                </Helmet>
                <Typography align="center" className={classes.title} variant="h3">
                    Projects
                </Typography>
                <Typography align="center" variant="h6">
                    Insulation to the basebuild ductwork infrasture including basements, risers and plantrooms. View our
                    gallery of projects.
                </Typography>
            </Container>
            <Container maxWidth="lg">
                <Fade>
                    <Gallery images={projectImages} title="London Insulation Projects" />
                </Fade>
            </Container>
        </div>
    );
}

export default ProjectPage;
